import { useState } from 'react';
import { generateId } from '../lib/utils.js';

const roleLabel = { project_admin: 'Administrador do projeto', school_admin: 'Gestão escolar', professional: 'Professor AEE', parent: 'Responsável' };

function linkedStudentNames(user, students, field) {
  return students.filter((student) => student[field]?.includes(user.uid)).map((student) => student.nome).join(', ') || '-';
}

export function UserAdmin({ user, data, setData, onSave }) {
  const schoolId = user?.schoolId;
  const schoolUsers = data.users.filter((item) => (item.schoolIds || [item.schoolId]).includes(schoolId) && item.role !== 'project_admin');
  const schoolStudents = data.students.filter((student) => student.schoolId === schoolId);
  const [form, setForm] = useState({ nome: '', email: '', password: '123456', role: 'professional' });
  const [message, setMessage] = useState('');

  function persist(next, msg) {
    setData(next);
    onSave(next);
    setMessage(msg);
  }

  function addUser(e) {
    e.preventDefault();
    if (data.users.some((item) => item.email === form.email)) {
      setMessage('Já existe usuário com este e-mail.');
      return;
    }
    const newUser = { uid: generateId('usr'), schoolId, ...form };
    persist({ ...data, users: [...data.users, newUser] }, 'Usuário criado em modo local.');
    setForm({ nome: '', email: '', password: '123456', role: 'professional' });
  }

  function removeUser(uid) {
    const next = {
      ...data,
      users: data.users.filter((item) => item.uid !== uid),
      students: data.students.map((student) => student.schoolId !== schoolId ? student : ({
        ...student,
        profissionais: (student.profissionais || []).filter((id) => id !== uid),
        responsaveis: (student.responsaveis || []).filter((id) => id !== uid)
      }))
    };
    persist(next, 'Usuário removido dos vínculos locais.');
  }

  function toggleLink(studentId, uid, field) {
    const next = {
      ...data,
      students: data.students.map((student) => {
        if (student.id !== studentId || student.schoolId !== schoolId) return student;
        const current = new Set(student[field] || []);
        current.has(uid) ? current.delete(uid) : current.add(uid);
        return { ...student, [field]: Array.from(current) };
      })
    };
    persist(next, 'Vínculo atualizado.');
  }

  const professionals = schoolUsers.filter((item) => item.role === 'professional');
  const parents = schoolUsers.filter((item) => item.role === 'parent');

  return <><header className='header'><div><p>administração da escola</p><h1>Usuários e vínculos</h1><span>Cadastro local de profissionais, responsáveis e vínculos com estudantes da sua escola.</span></div></header><div className='split'><section className='card'><h2>Novo usuário local</h2><form className='form' onSubmit={addUser}><label>Nome<input required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></label><label>E-mail<input required type='email' value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></label><label>Senha inicial<input required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></label><label>Perfil<select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}><option value='professional'>Professor AEE</option><option value='parent'>Responsável</option><option value='school_admin'>Gestão escolar</option></select></label><button>Criar usuário</button></form>{message && <p className='hint'>{message}</p>}</section><section className='card'><h2>Usuários cadastrados</h2><div className='list'>{schoolUsers.map((item) => <article key={item.uid}><h3>{item.nome}</h3><small>{roleLabel[item.role] || item.role} · {item.email}</small><p><b>Profissional em:</b> {linkedStudentNames(item, schoolStudents, 'profissionais')}</p><p><b>Responsável por:</b> {linkedStudentNames(item, schoolStudents, 'responsaveis')}</p>{item.uid !== 'admin_demo' && <button type='button' onClick={() => removeUser(item.uid)}>Remover usuário local</button>}</article>)}</div></section></div><section className='card'><h2>Vínculos por estudante</h2><div className='list'>{schoolStudents.map((student) => <article key={student.id}><h3>{student.nome}</h3><p>{student.serie} · {student.necessidade}</p><div className='inline-grid'><div><b>Profissionais</b>{professionals.map((item) => <label key={item.uid} className='checkline'><input type='checkbox' checked={(student.profissionais || []).includes(item.uid)} onChange={() => toggleLink(student.id, item.uid, 'profissionais')} />{item.nome}</label>)}</div><div><b>Responsáveis</b>{parents.map((item) => <label key={item.uid} className='checkline'><input type='checkbox' checked={(student.responsaveis || []).includes(item.uid)} onChange={() => toggleLink(student.id, item.uid, 'responsaveis')} />{item.nome}</label>)}</div></div></article>)}</div></section></>;
}
